module.exports = __webpack_public_path__ + "img/music-test-icon4.812ecffb.png";